export function ChatMessageText({ children }: { children: string }) {
  return <>{children}</>;
}
